import React from 'react'
import {Input} from "antd";
import AppButton from "../../../components/button";
import {connect} from "react-redux";
import {nextStage} from "../../../redux/actions";

const TestnetTab = ({
    stage,
    ...props
}) =>{
    return(
        <div className={'col center'}>
            {
                stage==4?
                    <div className={'font-lg'}>
                        Published to Testnet
                    </div>
                    :
                    <>
                Publish to Testnet
                <br/>
                <br/>
                <Input style={{width:280,textAlign:'center'}} placeholder={'Enter Game contract address'} />
                <br/>
                <br/>
                <AppButton glow
                onClick={()=>{
                    props.dispatch(nextStage())
                }
                }
                >
                SUBMIT
                </AppButton>
                </>
            }
        </div>
    )
}

const mapStateToProps = (store) => ({
    stage: store.appReducer.stage

})


export default connect(mapStateToProps)(TestnetTab)